"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), function(from, to) {
    Object.keys(from).forEach(function(k) {
        "default" === k || Object.prototype.hasOwnProperty.call(to, k) || Object.defineProperty(to, k, {
            enumerable: !0,
            get: function() {
                return from[k];
            }
        });
    });
}(require("./CommonProtoTransfer.TransferRequestStatus"), exports);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hcGkvZ2VuZXJhdGVkL0NvbW1vblByb3RvVHJhbnNmZXIvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gdHNsaW50OmRpc2FibGVcbmV4cG9ydCAqIGZyb20gJy4vQ29tbW9uUHJvdG9UcmFuc2Zlci5UcmFuc2ZlclJlcXVlc3RTdGF0dXMnO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztVQUNjIn0=